module.exports = __webpack_public_path__ + "static/media/PlantsOfLife.48edd310.png";